module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_4.4b3d0bb3.png";